/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// react-routers components
import { useState, useEffect } from "react";

// prop-types is library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";

import PermissionsTransferList from "./components/permissionsTransferList";
import PlatformsTransferList from "./components/platformsTransferList";
import ChangePassword from "views/users/account/components/ChangePassword";

// Soft UI Dashboard PRO React base styles
import colors from "assets/theme/base/colors";
import typography from "assets/theme/base/typography";

// sweetalert2 components
import Swal from "sweetalert2";


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <SoftBox sx={{}}>
          <SoftBox>{children}</SoftBox>
        </SoftBox>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function ProfileComponentsCard({ userId, tab, informProfile }) {
      const { socialMediaColors } = colors;
  const { size } = typography;
  const [checkChanges, setCheckChanges] = useState(false);
  const [disabled, setTabDisabled] = useState(false);

  const [value, setValue] = useState(0);
  const [nextTab, setNextTab] = useState(0);

  const sleep = (ms) =>
    new Promise((resolve) => {
      setTimeout(resolve, ms);
    });

  const changeTab = async (event, newValue) => {
    event.preventDefault();
    setTabDisabled(true);
    setNextTab(newValue);
    setCheckChanges(true);
    await sleep(1000);
    setTabDisabled(false);
  };

  const handleChange = (changesExist, newValue) => {
    if (changesExist && value != newValue) {
      Swal.fire({
        title: `Unsaved Data`,
        html: `You are going to lose User changes. <br />
                  Are you sure?`,
        showDenyButton: true,
        showConfirmButton: true,
        confirmButtonText: "Yes",
        denyButtonText: "Cancel",
        icon: "warning",
        confirmButtonColor: "#87cb16",
        denyButtonColor: "#ff4a55",
      }).then(async (result) => {
        if (result.isConfirmed) {
          setValue(newValue);
          informProfile({ changeTab: newValue });
          setCheckChanges(false);
        } else {
          setCheckChanges(false);
        }
      });
    } else {
      setValue(newValue);
      informProfile({ changeTab: newValue });
      setCheckChanges(false);
    }
  };

  const informParent = (changesExist, name) => {
    if (changesExist == "update") {
      informProfile({ refresh: true });
      return;
    }
    handleChange(changesExist, nextTab);
  };

  useEffect(() => {
    if (tab || tab == 0) {
      changeTab(new Event("change button"), tab);
    }
  }, [tab]);

  return (
    <Card sx={{ height: "100%", width: "100%" }}>
      <SoftBox display="flex" justifyContent="space-between" alignItems="flex-start" p={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12}>
            <SoftBox sx={{ borderBottom: 1, borderColor: "divider" }} sm={12}>
              <Tabs value={value} onChange={changeTab} aria-label="basic tabs example">
                <Tab label="Permissions" {...a11yProps(0)} disabled={disabled} />
                <Tab label="Platforms" {...a11yProps(1)} disabled={disabled} />
                <Tab label="Password" {...a11yProps(2)} disabled={disabled} />
              </Tabs>
            </SoftBox>
          </Grid>
          <Grid item xs={12} sm={12}>
            <SoftBox sm={12}>
              <TabPanel value={value} index={0}>
                <PermissionsTransferList
                  userId={userId}
                  className="transfer-list-holder"
                  informParent={informParent}
                  checkChanges={checkChanges}
                ></PermissionsTransferList>
              </TabPanel>
              <TabPanel value={value} index={1}>
                <PlatformsTransferList
                  userId={userId}
                  className="transfer-list-holder"
                  informParent={informParent}
                  checkChanges={checkChanges}
                ></PlatformsTransferList>
              </TabPanel>
              <TabPanel value={value} index={2}>
                <ChangePassword
                  informParent={informParent}
                  checkChanges={checkChanges}
                ></ChangePassword>
              </TabPanel>
            </SoftBox>
          </Grid>
        </Grid>
      </SoftBox>
    </Card>
  );
}

// Typechecking props for the ProfileInfoCard
ProfileComponentsCard.propTypes = {
  userId: PropTypes.number.isRequired,
  tab: PropTypes.number,
  informProfile: PropTypes.func,
};

export default ProfileComponentsCard;
